export default () => ({
  selectedQuality: '',
  history: [],
  redirectTo: null
})
